import type { CampaignResultDay } from '../outreachTypes';

/** The top of the chart: the most pitches of one day, at least 1 (a day with no pitch has an empty bar). */
export function dailyChartTop(days: CampaignResultDay[]): number {
  return Math.max(1, ...days.map((day) => day.pitched));
}

/** The share (0-100) of a count in the chart height. */
export function barPercent(count: number, top: number): number {
  return Math.round((Math.min(count, top) / top) * 1000) / 10;
}

/** Every n-th day gets a label under the chart, so at most 8 labels show. */
export function dayLabelStep(count: number): number {
  return Math.max(1, Math.ceil(count / 8));
}
